import styled from "styled-components";

export const StyledDrinkList = styled.section`
  padding: 1rem;

  max-width: 1200px;
  width: 100%;

  p {
    text-align: justify;
    line-height: 1.2rem;

    span {
      font-weight: bold;
    }
  }
`;
